import normalizeThreadType from '@/lib/threads/normalizeThreadType.js';

const isOnboardingThreadType = (threadType) => {
  return normalizeThreadType(threadType, '') === 'onboarding';
};

export default isOnboardingThreadType;
